module.exports = __webpack_public_path__ + "static/avatar_snp-3dd256f2132f31cb60f5d3cb4c3a7653.png";